import { navItems } from "@/mocks/siteData";

export default function Hero() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20starfield%20with%20warm%20amber%20and%20deep%20crimson%20light%20streaks%2C%20soft%20bokeh%2C%20moody%20dark%20gradient%2C%20stylized%20artistic%20background%2C%20high%20contrast%20for%20text%20overlay%2C%20no%20people&width=1920&height=1080&seq=sc-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/85"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/50 via-transparent to-secondary-950/40"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-7xl px-5 md:px-8 py-24 md:py-28">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 backdrop-blur-sm mb-6 animate-fade-in">
            <i className="ri-planet-line text-accent-400" aria-hidden="true"></i>
            <span className="text-xs md:text-sm text-background-100 tracking-wide">星辰影院 · 在线观看与播放信息整理</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-[3.25rem] font-bold text-background-50 leading-tight md:leading-[1.15] animate-fade-up">
            星辰影院：把在线观看、免费观看、高清播放与手机在线讲清楚
          </h1>

          <p className="mt-6 text-base md:text-lg text-background-100/85 leading-relaxed max-w-2xl animate-fade-up" style={{ animationDelay: "120ms" }}>
            这里整理的是星辰影院各个观看方向的具体差别：从打开即播的在线观看，到标注即所得的免费观看，再到清晰度可选的高清播放与小屏友好的手机在线。
            页内补充抢先看片段与全集在线进度，方便你按需核对，而不是只看到一句口号。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 animate-fade-up" style={{ animationDelay: "220ms" }}>
            <button
              onClick={() => goTo("library")}
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-fill text-lg" aria-hidden="true"></i>
              查看影片片单
            </button>
            <button
              onClick={() => goTo("modes")}
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50/10 border border-background-50/25 text-background-50 font-medium hover:bg-background-50/20 transition-colors backdrop-blur-sm cursor-pointer whitespace-nowrap"
            >
              <i className="ri-equalizer-line text-lg" aria-hidden="true"></i>
              对比播放方式
            </button>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-6 gap-y-3 animate-fade-in" style={{ animationDelay: "320ms" }}>
            {[
              { icon: "ri-play-circle-line", text: "在线观看" },
              { icon: "ri-vip-diamond-line", text: "免费观看" },
              { icon: "ri-hd-line", text: "高清播放" },
              { icon: "ri-smartphone-line", text: "手机在线" },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-background-100/80 text-sm">
                <i className={`${item.icon} text-accent-400`} aria-hidden="true"></i>
                {item.text}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 md:mt-16 flex flex-wrap gap-2 animate-fade-in" style={{ animationDelay: "420ms" }}>
          {navItems.slice(1, 7).map((item) => (
            <button
              key={item.id}
              onClick={() => goTo(item.id)}
              className="px-3.5 py-1.5 rounded-full text-xs md:text-sm text-background-100/80 border border-background-50/15 hover:border-accent-400/60 hover:text-accent-300 transition-colors cursor-pointer backdrop-blur-sm"
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}